export class Formatters {
  static dateFormatterYYYYMMDD(date, withTime = false) {
    if (date == null) {
      return null;
    } else {
      let newDate = new Date(date);

      let dateDay = newDate.getDate().toString();
      if (dateDay < 10) {
        dateDay = "0" + dateDay.toString();
      } else {
        dateDay = dateDay.toString();
      }
      let dateMonth = newDate.getMonth() + 1;
      if (dateMonth < 10) {
        dateMonth = "0" + dateMonth.toString();
      } else {
        dateMonth = dateMonth.toString();
      }
      let dateYear = newDate.getFullYear().toString();

      let dateFormatted = `${dateYear}-${dateMonth}-${dateDay}`;

      if (withTime) {
        let hours = newDate.getHours().toString();
        if (hours < 10) {
          hours = "0" + hours.toString();
        } else {
          hours = hours.toString();
        }
        let minutes = newDate.getMinutes().toString();
        if (minutes < 10) {
          minutes = "0" + minutes.toString();
        } else {
          minutes = minutes.toString();
        }
        let seconds = newDate.getSeconds().toString();
        if (seconds < 10) {
          seconds = "0" + seconds.toString();
        } else {
          seconds = seconds.toString();
        }

        dateFormatted = `${dateFormatted} ${hours}:${minutes}:${seconds}`;
      }

      return dateFormatted;
    }
  }

  static formatListForModaleSelect(
    objectsArray,
    stringKeyToValue,
    stringKeyToText
  ) {
    let listForSelect = [];
    for (let index = 0; index < objectsArray.length; index++) {
      const element = {};
      element.value = objectsArray[index][stringKeyToValue];
      element.text = objectsArray[index][stringKeyToText];
      listForSelect.push(element);
    }
    return listForSelect;
  }

  static formatDate(value) {
    var m = new Date(value);
    var dateString =
      m.getFullYear() +
      "/" +
      ("0" + (m.getMonth() + 1)).slice(-2) +
      "/" +
      ("0" + m.getDate()).slice(-2);
    return dateString;
  }

  static formatDateAndHour(value) {
    var m = new Date(value);
    var dateString =
      m.getFullYear() +
      "/" +
      ("0" + (m.getMonth() + 1)).slice(-2) +
      "/" +
      ("0" + m.getDate()).slice(-2) +
      " " +
      ("0" + m.getHours()).slice(-2) +
      ":" +
      ("0" + m.getMinutes()).slice(-2) +
      ":" +
      ("0" + m.getSeconds()).slice(-2);
    return dateString;
  }

  static formatFileSize(bytes) {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const sizes = ["Bytes", "KB", "MB", "GB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return Math.round((bytes / Math.pow(k, i)) * 100) / 100 + " " + sizes[i];
  }

  static truncateFileName(name, maxLength = 100) {
    if (name.length <= maxLength) return name;
    const extension = name.split(".").pop();
    const nameWithoutExt = name.substring(0, name.lastIndexOf("."));
    const truncated = nameWithoutExt.substring(
      0,
      maxLength - extension.length - 4
    );
    return `${truncated}...${extension}`;
  }
}
